import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useModal } from 'src/components/Modals/ModalWrapperHooks';
import { AssetSection } from './SelectedAssets';
import { useBorrowAssetsStyle } from './BorrowAssets.style';

import { BorrowAmountFields } from '@/features/Modals/ui/BorrowModal/fields';
import { Agreement, Token } from '@/shared/api/borrow';

type BorrowAssetsProps = {
    collateralAssets: Token[];
    disabled?: boolean;
    agreement: Agreement;
};

const BorrowAssets = ({ collateralAssets, disabled, agreement }: BorrowAssetsProps) => {
    const classes = useBorrowAssetsStyle();

    const { watch } = useFormContext();

    const assetAmount = watch(BorrowAmountFields.ASSET_AMOUNT);

    const { modalProps } = useModal();
    const { tokenSymbol } = modalProps || {};

    const { assetSymbol } = {
        assetSymbol: tokenSymbol,
    };

    const noCollateralAssets = !collateralAssets?.some(
        (item: Token) => item.balance && Number(item.balance) > 0,
    );

    return (
        !noCollateralAssets && (
            <AssetSection
                agreement={agreement}
                disabled={disabled}
                assets={collateralAssets}
                assetAmount={assetAmount}
                assetSymbol={assetSymbol}
                classes={{
                    root: classes.collateralAssetRoot,
                }}
            />
        )
    );
};

export default BorrowAssets;
